import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import Popup from '../Common/Popup';

/**
 * The `ExitStatusFilterSelect` function is a React component that renders a dropdown filter for selecting a
 * exit status.
 * @returns a JSX element
 */
function ExitStatusFilterSelect({ defaultLabel = "All", ExitStatusOptions, setExitStatusOptions, customPathname, dataPath, isPopupOpen, setIsPopupOpen }) {
    const { exitStatusResponseData, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.exitStatus?.map(value => value.id) ?? [];
        setExitStatusOptions(exitStatusResponseData[dataPath]?.map(industry => ({ ...industry, isChecked: industryIds.includes(parseInt(industry.id)) })))
    }, [customPathname, dataPath, exitStatusResponseData, refineSearchFilters, setExitStatusOptions])

    const handleExitStatusChange = ((e) => {
        const { value } = e.target;
        const currentStatus = ExitStatusOptions.map((status) =>
            ({ ...status, isChecked: value === "" ? false : status.id === parseInt(value) })
        );
        setExitStatusOptions(currentStatus);
    });

    const selected = ExitStatusOptions?.filter(status => status.isChecked)?.at(0);

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100 text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">Exit Status <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {ExitStatusOptions.slice(0,2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selected?.name && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selected.name}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <div className="space-y-2">
                            <div className="max-h-60 overflow-y-auto space-y-2 grid grid-cols-3">
                                <label className="flex items-center space-x-2 pt-1 hover:bg-gray-50 rounded cursor-pointer">
                                    <input
                                        type="radio"
                                        name="exitStatus"
                                        value=""
                                        checked={!selected}
                                        onChange={handleExitStatusChange}
                                        className="text-[#BC8B20] focus:ring-[#BC8B20]"
                                    />
                                    <span className="text-sm font-semibold">{defaultLabel}</span>
                                </label>
                                {ExitStatusOptions?.map(status => (
                                    <label key={status.id} className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                        <input
                                            type="radio"
                                            name="exitStatus"
                                            value={status.id}
                                            checked={selected?.id === status.id}
                                            onChange={handleExitStatusChange}
                                            className="text-[#BC8B20] focus:ring-[#BC8B20]"
                                        />
                                        <span className="text-sm font-semibold">{status.name}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    );
}

export default ExitStatusFilterSelect


